import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTypeirrigation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21.98 14H22H21.98ZM5.35 13C6.54 13 6.77 14 8.68 14C10.63 14 10.77 13 12.01 13C13.2 13 13.43 14 15.34 14C17.29 14 17.43 13 18.67 13C19.86 13 20.07 13.98 21.98 14V12C20.79 12 20.56 11 18.65 11C16.7 11 16.56 12 15.32 12C14.13 12 13.9 11 11.99 11C10.04 11 9.9 12 8.66 12C7.47 12 7.24 11 5.33 11C3.38 11 3.24 12 2 12V14C3.9 14 4.17 13 5.35 13ZM18.67 15C16.72 15 16.58 16 15.34 16C14.15 16 13.92 15 12.01 15C10.06 15 9.91 16 8.67 16C7.43 16 7.29 15 5.34 15C3.39 15 3.24 16 2 16V18C3.95 18 4.11 17 5.34 17C6.58 17 6.72 18 8.67 18C10.62 18 10.77 17 12.01 17C13.2 17 13.43 18 15.34 18C17.28 18 17.43 17 18.67 17C19.86 17 20.09 18 22 18V16C20.76 16 20.62 15 18.67 15ZM5.35 9C6.54 9 6.77 10 8.68 10C10.63 10 10.77 9 12.01 9C13.2 9 13.43 10 15.34 10C17.29 10 17.43 9 18.67 9C19.86 9 20.07 9.98 21.98 10V8C20.79 8 20.56 7 18.65 7C16.7 7 16.56 8 15.32 8C14.13 8 13.9 7 11.99 7C10.04 7 9.9 8 8.66 8C7.47 8 7.24 7 5.33 7C3.38 7 3.24 8 2 8V10C3.9 10 4.17 9 5.35 9Z",
		fill: "#0092E4"
	})
});
export default SvgTypeirrigation;
